<div class="confirm-dialog" fxLayout="column">
  <div fxLayout="row">
    <h3>{{text}}</h3>
  </div>

  <app-dict
            [label]="label" [dictType]="dictType"
            [control]="reasonControl"
            [required]="true"
            [multiple]="false"
  ></app-dict>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
    <div>
      <button [disabled]="!reasonControl.value" (click)="confirm()" mat-raised-button color="warn"><span> Tak</span></button>
    </div>
    <div>
      <button (click)="decline()" mat-raised-button color="primary" class="confirm-dialog-decline-button"><span> Nie</span></button>
    </div>
  </div>
</div>
